import React from 'react';
import { DepositType } from './AddGoalDepositFlow';
import { Icon } from '../Icon';
import './DepositTypeSelector.css';

interface DepositTypeSelectorProps {
  value?: DepositType;
  onChange: (type: DepositType) => void;
  onBack: () => void;
  goalName: string;
}

export const DepositTypeSelector: React.FC<DepositTypeSelectorProps> = ({
  value,
  onChange,
  onBack,
  goalName
}) => {
  const depositTypes = [
    {
      id: 'onetime' as DepositType,
      icon: 'dollar-sign',
      title: 'Разовое пополнение',
      description: 'Пополнить цель один раз',
      example: 'Например: перевести 5,000₽ сейчас'
    },
    {
      id: 'recurring' as DepositType,
      icon: 'repeat',
      title: 'Регулярное пополнение',
      description: 'Автоматическое пополнение по расписанию',
      example: 'Например: по 1,000₽ каждый месяц'
    }
  ];

  return (
    <div className="deposit-type-selector step-content">
      <div className="deposit-type-selector__header">
        <button className="deposit-type-selector__back" onClick={onBack}>
          <Icon name="chevron_left" size={20} />
        </button>
        <div className="deposit-type-selector__header-content">
          <h2 className="deposit-type-selector__title">Пополнение цели</h2>
          <p className="deposit-type-selector__subtitle">
            {goalName}
          </p>
        </div>
      </div>

      <div className="deposit-type-selector__options">
        {depositTypes.map((type) => (
          <button
            key={type.id}
            className={`deposit-type-option ${value === type.id ? 'deposit-type-option--selected' : ''}`}
            onClick={() => onChange(type.id)}
          >
            <div className="deposit-type-option__icon">
              <Icon name={type.icon} size={32} color={value === type.id ? 'var(--color-primary)' : 'var(--color-text-secondary)'} />
            </div>
            <div className="deposit-type-option__content">
              <div className="deposit-type-option__title">{type.title}</div>
              <div className="deposit-type-option__description">{type.description}</div>
              <div className="deposit-type-option__example">{type.example}</div>
            </div>
            <div className="deposit-type-option__check">
              {value === type.id && <Icon name="check" size={20} color="var(--color-primary)" />}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

